import {

  ChangeDetectionStrategy,

  ChangeDetectorRef,

  Component,

  OnDestroy,

  OnInit,

  inject,

} from '@angular/core';

import { FormsModule } from '@angular/forms';

import { Subscription } from 'rxjs';

import { ButtonModule } from 'primeng/button';

import { DialogModule } from 'primeng/dialog';

import { InputTextModule } from 'primeng/inputtext';

import {

  ShareViaEmailContext,

  HeaderService,

} from '../../services/headerService';

import { JobService } from '../../services/business/job.service';



@Component({

  selector: 'app-share-via-email-modal',

  standalone: true,

  imports: [DialogModule, ButtonModule, InputTextModule, FormsModule],

  templateUrl: './share-via-email-modal.html',

  changeDetection: ChangeDetectionStrategy.OnPush,

})

export class ShareViaEmailModalComponent implements OnInit, OnDestroy {

  private readonly header = inject(HeaderService);

  private readonly cdr = inject(ChangeDetectorRef);

  private readonly jobService = inject(JobService);

  private sub?: Subscription;



  visible = false;

  context: ShareViaEmailContext = {};

  email = '';

  emailTouched = false;



  ngOnInit(): void {

    this.sub = this.header.getShareViaEmailModal().subscribe((s) => {

      this.visible = s.visible;

      this.context = s.context ?? {};

      if (!s.visible) {

        this.email = '';

        this.emailTouched = false;

      }

      this.cdr.markForCheck();

    });

  }



  ngOnDestroy(): void {

    this.sub?.unsubscribe();

  }



  onDialogHide(): void {

    this.visible = false;

    this.header.closeShareViaEmailModal();

  }



  onCancel(): void {

    this.visible = false;

    this.header.closeShareViaEmailModal();

    this.cdr.markForCheck();

  }



  onSend(): void {
    this.emailTouched = true;

    if (!this.isEmailValid()) {

      this.cdr.markForCheck();

      return;

    }

    this.jobService.sendMailShareJob({

      email: this.email,

      jobId: this.context.id ?? '',

      title: this.context.jobTitle ?? this.context.position_title ?? '',
      location: this.context.location ?? '',
      experience: this.context.experience ?? '',

      shareJobCall: 'shareJobCall',

      maskedUrl: this.context.maskedUrl ?? '',

    }).subscribe();

    this.header.closeShareViaEmailModal();

  }



  private isEmailValid(): boolean {

    const v = this.email.trim();

    if (!v) {

      return false;

    }

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

  }



  get emailInvalid(): boolean {
    return this.emailTouched && !this.isEmailValid();

  }

}


